import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  UpdateMasterCarRequest,
  DeleteMasterCarRequest,
  MasterCarApiRequest,
} from '@/data/payload/api/MasterCarRequest'
import { MasterCarPresenter } from '@/app/ui/presenters/MasterCarPresenter'
import { MasterCar } from '@/domain/entities/MasterCar'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface MasterCarState {
  masterCarData: MasterCar
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'masterCar' })
class MasterCars extends VuexModule implements MasterCarState {
  public masterCarData = new MasterCar(true, '')
  public isLoading = true
  public Pages = 0
  public Limit = 10
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'name', sortable: false },
    { key: 'imageCar', sortable: false },
    { key: 'carType', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    search: '',
  }

  @Action
  public async getMasterCarData() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterCarPresenter)
    presenter
      .loadMasterCar(this.paginationParam)
      .then((res: MasterCar) => {
        this.setLoading(false)
        this.setMasterCarData(res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
        //  console.log('data', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        router.push('/404/index')
        console.error('error', error)
      })
  }

  @Action
  public async postMasterCar(params: {
    name: string
    trainingActive: boolean
    sopActive: boolean
    imageCoverId: number
    imageThumbnailId: number
    imageLogoId: number
    tag: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(MasterCarPresenter)
    presenter
      .postMasterCar(
        new MasterCarApiRequest(
          params.name,
          params.trainingActive,
          params.sopActive,
          params.imageCoverId,
          params.imageThumbnailId,
          params.imageLogoId,
          params.tag
        )
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Training Category',
          message: res.message,
          type: 'success',
          duration: 3000,
        })
        this.getMasterCarData()
      })
      .catch((error) => {
        Vue.prototype.$notify({
          title: 'Training Category',
          message: 'error',
          type: 'error',
          duration: 3000,
        })
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async updateMasterCar(params: {
    id: number
    name: string
    trainingActive: boolean
    sopActive: boolean
    imageCoverId: number
    imageThumbnailId: number
    imageLogoId: number
    tag: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(MasterCarPresenter)
    presenter
      .updateMasterCar(
        new UpdateMasterCarRequest(
          params.name,
          params.trainingActive,
          params.sopActive,
          params.imageCoverId,
          params.imageThumbnailId,
          params.imageLogoId,
          params.tag
        ),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Training Category',
          message: res.message,
          type: 'success',
          duration: 3000,
        })
        this.getMasterCarData()
      })
      .catch((error) => {
        Vue.prototype.$notify({
          title: 'Training Category',
          message: 'error',
          type: 'error',
          duration: 3000,
        })
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async deleteMasterCar(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(MasterCarPresenter)
    presenter
      .deleteMasterCar(new DeleteMasterCarRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Master Category',
          message: res.message,
          type:
            res.message === 'Master Category cannot be deleted'
              ? 'error'
              : 'success',
          duration: 5000,
        })
        this.getMasterCarData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Mutation
  private setMasterCarData(masterCar: MasterCar) {
    this.masterCarData = masterCar
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }

  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }
  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}

export const MasterCarStateDataModule = getModule(MasterCars)
